import React from "react";
import TabbedPage from "../../../Elements/TabbedPage";
import AdHocExportWindowDescription from "./AdHocExportWindowDescription";
import AdHocExportItem from "./AdHocExportItem";
import AllExportAdmin from "./AllExport/AllExportAdmin";
import EomExportWindowDescription from "./EomExportWindowDescription";
import EOMExportItem from "./EOMExportItem";
import ExportQueueAdmin from "./ExportQueueAdmin";
import UploadPaymentReconciliationWindow from "./UploadPaymentReconciliationWindow";
import ButtonRow from "../../../Elements/ButtonRow";
import ShownPanelsEnum from "../../../Enums/ShownPanelsEnum";
import ButtonTypeEnum from "../../../Enums/ButtonTypeEnum";
import ErrorMessage from '../../../Elements/ErrorMessage';
import PaymentExportAllExportService from '../../../Services/PaymentExportAllExportService';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import UserService from '../../../Services/userService';

export default class PaymentExportAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      window: null,
    };
    this.showPanel = this.showPanel.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  componentDidMount() {}

  tabs = [
    { label: 'All Export', id: 'allexprt', icon: 'fa-solid fa-money-bill-1-wave', component: <AllExportAdmin /> },
    { label: 'Export Queue', id: 'exportqueue', icon: 'fa-solid fa-tree-deciduous', component: <ExportQueueAdmin /> },
  ];

  closePopup() {
    this.setState({ window: null });
  }

  showPanel(shownPanel) {
    if (shownPanel === ShownPanelsEnum.ReconcileExport) {
      this.setState({ window: <UploadPaymentReconciliationWindow clickOnCancel={this.closePopup} /> });
    } else if (shownPanel === ShownPanelsEnum.EOMExport) {
      this.setState({
        window: (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new EOMExportItem()}
            clickOnCancel={this.closePopup}
            clickOnSave={this.closePopup}
            windowDescription={EomExportWindowDescription}
            errorCode='PEA41'
          />
        ),
      });
    } else if (shownPanel === ShownPanelsEnum.AdHocExport) {
      // The wizard has no componentDidMount data-load hook, so preload the user's
      // offices (the AdHoc office picker is scoped to them) before opening it.
      UserService.GetOfficesOfTheUser().then((offices) => {
        const editedItem = new AdHocExportItem();
        editedItem.AllOffice = offices;
        this.setState({
          window: (
            <GeneralEditWizzardBase
              crudType={CrudTypesEnum.Create}
              editedItem={editedItem}
              clickOnCancel={this.closePopup}
              clickOnSave={this.closePopup}
              windowDescription={AdHocExportWindowDescription}
              errorCode='PEA43'
            />
          ),
        });
      });
    } else if (shownPanel === ShownPanelsEnum.SomethingElse) {
      this.setState({ window: null });
      ErrorMessage.SetApprove(
        'You will create a backup from the Caspian DB. The process will remove all previous backup from the specified folder.',
        this.createDbBackup.bind(this)
      );
    }
  }

  // This function creates a DB backup.
  // It is called when the user clicks the "Create DB Backup" button.
  createDbBackup() {
    PaymentExportAllExportService.createDbBackup()
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        ErrorMessage.SetNotification('DB backup has been finished successfully.');
      })
      .catch((error) => ErrorMessage.SetErrorMessage('Error in DB Backup. ErrorCode: PEA77'));
    ErrorMessage.SetNotification(
      'The DB backup creation has been started. You will get a message into your personal message repository about the result.',
      this.createDbBackup.bind(this)
    );
  }

  renderActionButtons() {
    return (
      <ButtonRow
        labels={['Backup DB', 'Reconcile Export Payments', 'EOM Export', 'Ad Hoc Export']}
        keys={[
          ShownPanelsEnum.SomethingElse,
          ShownPanelsEnum.ReconcileExport,
          ShownPanelsEnum.EOMExport,
          ShownPanelsEnum.AdHocExport,
        ]}
        onClick={this.showPanel}
        buttonTypes={[
          ButtonTypeEnum.NormalNormal,
          ButtonTypeEnum.ExtraLargeNormal,
          ButtonTypeEnum.NormalNormal,
          ButtonTypeEnum.NormalNormal,
        ]}
        roles={[
          'justForAdmins',
          'ExportPayment_FigmaButtonRowButton',
          'ExportPayment_FigmaButtonRowButton',
          'ExportPayment_FigmaButtonRowButton',
        ]}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.window}
        <div className='bg-white p-1'>
          {this.renderActionButtons()}
          <div className='TabbedPage'>
            <TabbedPage tabs={this.tabs} />
          </div>
        </div>
      </div>
    );
  }
}
